import { Button, Dropdown, Navbar } from "flowbite-react";
import logo from "../images/noracares_german.svg";
import * as React from "react";
import { LocalizedLink } from "gatsby-plugin-i18n-l10n";
import LanguageSwitcher from "./LanguageSwitcher";
import { translate } from "../i18n/translate";
import { navigationItems } from "../constants";

const DropdownMenu = ({
  label,
  items,
}: {
  label: string;
  items: {
    label: string;
    href: string;
  }[];
}) => (
  <Dropdown.Item className="!w-full">
    <Dropdown
      inline
      className="!left-[80%]"
      renderTrigger={() => (
        <div className="flex justify-between gap-3 !w-full">
          <span> {translate(label)}</span>
          <svg
            stroke="currentColor"
            fill="none"
            stroke-width="2"
            viewBox="0 0 24 24"
            aria-hidden="true"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 9l-7 7-7-7"
            ></path>
          </svg>
        </div>
      )}
      dismissOnClick={false}
    >
      {items.map((item, index) => (
        <Dropdown.Item
          key={`${index}-${item.label}`}
          className="py-2 px-4 min-w-[200px] text-left"
        >
          <LocalizedLink to={item.href} className="!w-full">
            {translate(item.label)}
          </LocalizedLink>
        </Dropdown.Item>
      ))}
    </Dropdown>
  </Dropdown.Item>
);

const NavigationContent = () => (
  <>
    <Dropdown
      arrowIcon={true}
      inline
      label={translate("services")}
      dismissOnClick={false}
      className={"[&_ul]:list-none [&_ul]:m-0 [&_li]:m-0"}
    >
      {navigationItems.map((item, index) => {
        return (
          <DropdownMenu key={index} label={item.label} items={item.items} />
        );
      })}
    </Dropdown>
    <LocalizedLink to="/blog/">{translate("blog")}</LocalizedLink>
    <LocalizedLink to="/help-center/">{translate("help")}</LocalizedLink>
    <LocalizedLink to="/about-us/">
      {translate("aboutUs.meta.title")}
    </LocalizedLink>
  </>
);

export const Header = ({ showLanguageSwitcher = true }) => {
  return (
    <Navbar
        style={{color: "rgb(17 24 39 / var(--tw-text-opacity, 1))"}}
      fluid
      rounded
      className="fixed start-0 top-0 z-20 w-full border-b border-gray-200 bg-white dark:border-gray-600 dark:bg-gray-900 sm:px-4 py:2.5"
    >
      <Navbar.Brand>
        <LocalizedLink to="/">
          <img src={logo} className="h-8" alt="Nora Cares Logo" />
        </LocalizedLink>
      </Navbar.Brand>

      <div className="flex space-x-3 md:order-2 items-center">
        <Button
          className={
            "bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-0"
          }
          onClick={() =>
            (window.location.href =
                `${process.env.GATSBY_DASHBOARD_URL}/authorizationLanding`)
          }
        >
          {translate("header.getStarted")}
        </Button>
        {showLanguageSwitcher && <LanguageSwitcher />}

        <Navbar.Toggle className="md:hidden" />
      </div>

      <div className="hidden md:flex space-x-8 text-sm font-medium ">
        <NavigationContent />
      </div>

      <Navbar.Collapse className="md:hidden">
        <NavigationContent />
      </Navbar.Collapse>
    </Navbar>
  );
};
